import { NavLink } from "react-router-dom";
import { FaBell, FaFilePdf, FaHome } from "react-icons/fa";
import { MdOutlineCardMembership, MdPersonOutline, MdSettings } from "react-icons/md";
import { useMemo, useState } from "react";
import Navbar from "../../Navbar/Navbar";
import { PRODUCT_DISPLAY_NAME } from "../../constants/branding";
import { printSalesPresentation } from "../../utils/salesPresentationPdf";

const routes = [
  {
    path: "/dashboard",
    name: "Platform overview",
    icon: <FaHome />,
  },
  {
    path: "/client",
    name: "Agencies",
    icon: <MdPersonOutline />,
  },

  {
    path: "/subscriptionplans",
    name: "Subscription plans",
    icon: <MdOutlineCardMembership />,
  },

  {
    name: "Sales presentation PDF",
    icon: <FaFilePdf />,
    action: printSalesPresentation,
  },

  // {
  //   path: "/leads",
  //   name: "Leads",
  //   icon: <MdAddCircleOutline />,
  // },

  // {
  //   path: "/leadassigned",
  //   name: "Assigned Leads",
  //   icon: <MdAddBox />,
  // },

  // {
  //   path: "/pendingfollowups",
  //   name: "Pending FollowUps",
  //   icon: <FaUserAlt />,
  // },

  {
    path: "/settings",
    name: "Platform settings",
    icon: <MdSettings />,
  },

  {
    path: "/notification-engine",
    name: "Notifications",
    icon: <FaBell />,
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   icon: <MdInfo />,
  // },
  // {
  //   path: "/privacy",
  //   name: "Privacy",
  //   icon: <MdPrivacyTip />,
  // },
  // {
  //   path: "/termsandconditions",
  //   name: "Terms and Conditions",
  //   icon: <MdOutlineSecurity />,
  // },
];

const SideBar = ({ children }) => {
  const [isOpen] = useState(true);
  const [menuSearch, setMenuSearch] = useState("");

  const filteredRoutes = useMemo(() => {
    const q = menuSearch.trim().toLowerCase();
    if (!q) return routes;
    return routes.filter((r) => r.name.toLowerCase().includes(q));
  }, [menuSearch]);
  const closeSidebar = () => {
    document.body.classList.remove("sidebar-open");
  };

  return (
    <>
      <div
        className="sidebar-backdrop"
        onClick={closeSidebar}
        aria-hidden="true"
      />
      <aside
        className="sidenav navbar navbar-vertical navbar-expand-xs border-radius-lg fixed-start ms-2 my-2"
        id="sidenav-main"
      >
        <div className="sidenav-header">
          <i
            className="fas fa-times p-3 cursor-pointer text-white opacity-6 position-absolute end-0 top-0 d-none d-xl-none"
            aria-hidden="true"
            id="iconSidenav"
          ></i>
          <NavLink
            className="navbar-brand nf-sidebar-brand"
            to="/dashboard"
            onClick={closeSidebar}
          >
            <span className="nf-sidebar-brand-name">{PRODUCT_DISPLAY_NAME}</span>
            <span className="nf-sidebar-brand-sub">Super Admin</span>
          </NavLink>
        </div>
        <div className="nf-sidebar-search-wrap">
          <div className="nf-sidebar-search">
            <i className="fas fa-search nf-sidebar-search-icon" aria-hidden="true" />
            <input
              type="search"
              className="nf-sidebar-search-input"
              placeholder="Search menu…"
              value={menuSearch}
              onChange={(e) => setMenuSearch(e.target.value)}
              aria-label="Search navigation"
            />
          </div>
        </div>
        <hr className="horizontal dark mt-0 mb-2" />
        <div
          className="collapse navbar-collapse w-auto"
          id="sidenav-collapse-main"
        >
          <section className="routes">
            <div className="nf-sidebar-section-label text-uppercase">Menu</div>
            <ul className="navbar-nav">
              {filteredRoutes.map((route, index) => (
                <li className="nav-item" key={`${route.path || route.name}-${index}`}>
                  {route.action ? (
                    <button
                      type="button"
                      className="nav-link d-flex align-items-center w-100 border-0 bg-transparent text-start"
                      onClick={() => {
                        route.action();
                        closeSidebar();
                      }}
                    >
                      <div className="icon me-2">{route.icon}</div>
                      {isOpen && <div className="link_text">{route.name}</div>}
                    </button>
                  ) : (
                    <NavLink
                      to={route.path}
                      className={({ isActive }) =>
                        `nav-link d-flex align-items-center${isActive ? " active" : ""}`
                      }
                      onClick={closeSidebar}
                    >
                      <div className="icon me-2">{route.icon}</div>
                      {isOpen && <div className="link_text">{route.name}</div>}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </section>
        </div>
      </aside>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
        <Navbar />
        <div className="container-fluid py-2">{children}</div>
      </main>
    </>
  );
};

export default SideBar;
